<template>
  <router-view />
</template>

<style lang="less">
@font-face {
  font-family: 'YouSheShaYuFeiTeJianKangTi';
  src: url('./assets/fonts/YouSheShaYuFeiTeJianKangTi.ttf') format('truetype');
  font-weight: normal;
  font-style: normal;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif, YouSheShaYuFeiTeJianKangTi;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.el-button:hover {
  color: inherit !important;
}



* {
  -webkit-font-smoothing: antialiased;
  /* Chrome/Safari 抗锯齿 */
  -moz-osx-font-smoothing: grayscale;
  /* Firefox 抗锯齿 */
}

body {
  margin: 0;
  padding: 0;
}
</style>
